import getDateButtonText from './get-date-button-text';

export { getDateButtonText };

export default getDateButtonText;
